const computerVisionProjects = [
  {
    id: "face-recognition-attendance",
    title: "Face Recognition Attendance System",
    category: "Computer Vision",
    domain: "Education",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Automated attendance system using face detection and face recognition.",
    description:
      "Build a computer vision attendance platform that detects and recognizes registered students and automatically records their attendance.",
    technologies: [
      "Python",
      "OpenCV",
      "Face Recognition",
      "React",
      "Node.js",
      "MongoDB",
    ],
    skills: [
      "Computer Vision",
      "Face Detection",
      "Face Recognition",
      "Python",
      "OpenCV",
    ],
    features: [
      "Student registration",
      "Face capture",
      "Face recognition",
      "Automatic attendance",
      "Attendance reports",
      "Admin dashboard",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "ai-object-detection",
    title: "AI Object Detection System",
    category: "Computer Vision",
    domain: "Artificial Intelligence",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Detect and classify multiple objects from images and live camera feeds using AI.",
    description:
      "Develop an object detection application capable of identifying and classifying objects from uploaded images or real-time camera input.",
    technologies: [
      "Python",
      "OpenCV",
      "YOLO",
      "Deep Learning",
      "React",
    ],
    skills: [
      "Object Detection",
      "Deep Learning",
      "Computer Vision",
      "Model Training",
      "Python",
    ],
    features: [
      "Image upload",
      "Live camera detection",
      "Object classification",
      "Bounding boxes",
      "Confidence scores",
      "Detection history",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "vehicle-detection-system",
    title: "AI Vehicle Detection & Counting",
    category: "Computer Vision",
    domain: "Smart Transportation",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Detect and count vehicles from traffic camera footage using computer vision.",
    description:
      "Build an intelligent traffic monitoring system that detects vehicles, tracks movement and calculates vehicle counts from video streams.",
    technologies: [
      "Python",
      "OpenCV",
      "YOLO",
      "Deep Learning",
      "Computer Vision",
    ],
    skills: [
      "Object Detection",
      "Object Tracking",
      "Video Processing",
      "Python",
      "Computer Vision",
    ],
    features: [
      "Vehicle detection",
      "Vehicle counting",
      "Video processing",
      "Object tracking",
      "Traffic analytics",
      "Reports",
    ],
    suitableFor: ["MCA", "B.Tech", "BE"],
  },
  {
    id: "emotion-detection",
    title: "Facial Emotion Detection",
    category: "Computer Vision",
    domain: "Human Computer Interaction",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Analyze facial expressions and classify emotions using computer vision and deep learning.",
    description:
      "Develop an AI system that detects faces and predicts facial expressions such as happy, sad, angry, neutral and other trained emotion classes.",
    technologies: [
      "Python",
      "OpenCV",
      "TensorFlow",
      "Keras",
      "Deep Learning",
    ],
    skills: [
      "Image Classification",
      "CNN",
      "Face Detection",
      "Deep Learning",
      "Model Evaluation",
    ],
    features: [
      "Face detection",
      "Emotion classification",
      "Live camera mode",
      "Confidence score",
      "Prediction history",
      "Analytics",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "number-plate-recognition",
    title: "Automatic Number Plate Recognition",
    category: "Computer Vision",
    domain: "Smart Transportation",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Detect vehicle number plates and extract registration numbers using OCR.",
    description:
      "Create an automated number plate recognition system that detects vehicle plates from images or video and extracts plate text using OCR.",
    technologies: [
      "Python",
      "OpenCV",
      "OCR",
      "YOLO",
      "Tesseract",
    ],
    skills: [
      "Image Processing",
      "Object Detection",
      "OCR",
      "Computer Vision",
      "Python",
    ],
    features: [
      "Plate detection",
      "OCR extraction",
      "Vehicle image processing",
      "Searchable records",
      "Entry logs",
      "Reports",
    ],
    suitableFor: ["MCA", "B.Tech", "BE"],
  },
  {
    id: "pothole-detection",
    title: "AI Road Pothole Detection",
    category: "Computer Vision",
    domain: "Smart City",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Detect potholes from road images using computer vision and deep learning.",
    description:
      "Develop a road monitoring system that identifies potholes from images or video and provides structured information for maintenance teams.",
    technologies: [
      "Python",
      "OpenCV",
      "YOLO",
      "Deep Learning",
      "React",
    ],
    skills: [
      "Object Detection",
      "Image Processing",
      "Deep Learning",
      "Computer Vision",
      "Model Training",
    ],
    features: [
      "Pothole detection",
      "Image upload",
      "Severity classification",
      "Location records",
      "Detection history",
      "Dashboard",
    ],
    suitableFor: ["MCA", "B.Tech", "BE"],
  },
  {
    id: "medical-image-classification",
    title: "Medical Image Classification",
    category: "Computer Vision",
    domain: "Healthcare AI",
    difficulty: "Advanced",
    duration: "8-12 Weeks",
    price: "₹4499",
    shortDescription:
      "Classify medical images using deep learning models for academic research and analysis.",
    description:
      "Build an academic medical image classification system using a suitable public dataset and deep learning classification techniques.",
    technologies: [
      "Python",
      "TensorFlow",
      "Keras",
      "CNN",
      "OpenCV",
      "React",
    ],
    skills: [
      "Deep Learning",
      "CNN",
      "Image Classification",
      "Model Evaluation",
      "Python",
    ],
    features: [
      "Image upload",
      "Preprocessing",
      "AI classification",
      "Confidence score",
      "Prediction history",
      "Analytics dashboard",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "gesture-recognition",
    title: "Hand Gesture Recognition System",
    category: "Computer Vision",
    domain: "Human Computer Interaction",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "Recognize hand gestures from camera input and map them to application commands.",
    description:
      "Create a real-time hand gesture recognition application using computer vision and machine learning techniques.",
    technologies: [
      "Python",
      "OpenCV",
      "MediaPipe",
      "Machine Learning",
      "React",
    ],
    skills: [
      "Gesture Recognition",
      "Computer Vision",
      "MediaPipe",
      "Machine Learning",
      "Python",
    ],
    features: [
      "Live camera input",
      "Hand detection",
      "Gesture classification",
      "Command mapping",
      "Real-time processing",
      "Gesture history",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech"],
  },
  {
    id: "people-counting-system",
    title: "AI People Counting System",
    category: "Computer Vision",
    domain: "Smart Monitoring",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Detect and count people in video streams for smart monitoring and analytics.",
    description:
      "Develop a computer vision system that detects people and tracks movement through defined areas to generate occupancy analytics.",
    technologies: [
      "Python",
      "OpenCV",
      "YOLO",
      "Deep Learning",
      "Computer Vision",
    ],
    skills: [
      "Object Detection",
      "Object Tracking",
      "Video Analytics",
      "Python",
      "Computer Vision",
    ],
    features: [
      "People detection",
      "Real-time counting",
      "Entry/exit tracking",
      "Occupancy monitoring",
      "Analytics",
      "Reports",
    ],
    suitableFor: ["MCA", "B.Tech", "BE"],
  },
  {
    id: "mask-detection-system",
    title: "Face Mask Detection System",
    category: "Computer Vision",
    domain: "Safety Monitoring",
    difficulty: "Intermediate",
    duration: "5-7 Weeks",
    price: "₹2499",
    shortDescription:
      "Detect whether people are wearing protective masks using computer vision.",
    description:
      "Build an image classification and face detection system that identifies mask and no-mask conditions from camera input.",
    technologies: [
      "Python",
      "OpenCV",
      "TensorFlow",
      "Keras",
      "CNN",
    ],
    skills: [
      "Image Classification",
      "Face Detection",
      "CNN",
      "Computer Vision",
      "Python",
    ],
    features: [
      "Face detection",
      "Mask classification",
      "Live camera",
      "Confidence score",
      "Detection logs",
      "Analytics",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech"],
  },
];

export default computerVisionProjects;